import { z } from 'zod';

import { CompanyAuditLogId, CompanyId, UserId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';

export const CompanyAuditLogEventType = z.enum([
  'updateCompany',
  'updateLogo',
  'updateCompanyAdminSettings',
  'updateCompanyPortalSettings',
  'deleteAllLoans',
  'setPaymentsPaused',
  'updateCompanyTaskSettings',
  'updateCompanyReportSettings',
  'updatePortalSettings',

  'generatePortalDomainSslCert',
  'attachPortalDomainSslCert',
  'bulkSendEmails',
]);
export type CompanyAuditLogEventType = z.infer<typeof CompanyAuditLogEventType>;

export const CompanyAuditLogEvent = z.object({
  id: CompanyAuditLogId,
  companyId: CompanyId,
  userId: UserId.optional(), // optional for preserving audit log items of deleted users
  type: CompanyAuditLogEventType,
  comment: z.string(),
  adminViewComment: z.string(),
  hidden: z.boolean(),
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});
export type CompanyAuditLogEvent = z.infer<typeof CompanyAuditLogEvent>;
